<template>
  <el-dropdown
    @command="handleCommand"
    class="flexRowCenter dropdown2"
    style="cursor:pointer;"
    :trigger="isMobileApp ? 'click' : 'hover'"
    id="dropdown1"
  >
    <div class="flexRowCenter">
      <img
        :src="imgUrl"
        alt=""
        class="img1"
        v-if="imgUrl"
      />
      <img :src="getOne(selectId).url" alt="" v-if="getOne(selectId) && getOne(selectId).url">
      <span style="white-space: nowrap;">{{ getOne(selectId) ? getOne(selectId).name || emptyValue : emptyValue}}</span>
      <i class="el-icon-arrow-down el-icon--right" v-if="showArrows"></i>
      <img class="img-r" src="@/assets/images/arrow-down.png" alt="" v-if="showTriangle">
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        :command="item.id"
        v-for="(item, index) in selectOptions"
        :key="index"
      >{{ item.name }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    //下拉选项
    selectOptions: {
      type: Array,
      default: [],
    },
    //初始值
    value: {
      type: Number,
      default: "",
    },
    //没有选择值时显示什么
    emptyValue: {
      type: String,
      default: "请选择",
    },
    //是否显示箭头
    showArrows: {
      type: Boolean,
      default: false,
    },
    showTriangle: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
    },
  },
  computed: {
    getOne() {
      return function (id) {
        const item = this.selectOptions.find((i) => i.id === id);
        return item ? item : "";
      };
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal) {
        this.selectId = newVal;
      }
    },
  },
  data() {
    return {
      selectId: "",
      isMobileApp: false,
    };
  },
  created() {
    if(this.value) {
      this.selectId = this.value
    }
    const userAgent = navigator.userAgent
    this.isMobileApp = this.$store.state.isMobileApp
  },
  methods: {
    handleCommand(command) {
      this.selectId = command;
      this.$emit("change", command);
    },
    clickDropdown() {
      // console.log('343');
      // document.getElementById("dropdown1").click();
    }
  },
};
</script>

<style lang="less" scoped>
.img1 {
  width: 19px;
  height: 19px;
  margin-right: 4px;
}
.img-r{
  width: 15px;
  height: 15px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/selectMenu.vue